import type { SnackType } from '../types';

export const SNACKBAR_TRANSITION_DURATION = 10000;

export const uiClasses: { [key in SnackType]: string } = {
  info: 'text-blue-600',
  error: 'text-red-500',
  success: 'text-emerald-600',
  warn: 'text-amber-600',
};
